import axios from 'axios';
import store from '@/store';
import router from '@/router';

import {
    MessageBox,
    Message
} from 'element-ui';


const service = axios.create({
    method: 'post',
    baseURL: store.state.baseUrl, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000, // request timeout
});


service.interceptors.response.use(
    response => {
        // console.log("res:", response.data);
        const res = response.data;
        if (res.code != undefined) {
            if (res.code === 0) {    //请求未报错
                return res;
            } else if (res.code == 1) {
                Message({ message: res.msg, type: 'error', duration: 5 * 1000 });
                return Promise.reject(res.msg || 'error');
            } else if(res.code==200){//请求报错
                router.push('/MemberRegistered')
                store.commit('SET_TOKEN', '')
                store.commit('SET_USER', null)
                localStorage.setItem('SET_TOKEN', "");
                localStorage.setItem('SET_USER',null);
                Message({ message: res.msg, type: 'error', duration: 5 * 1000 });
                return Promise.reject(res.msg || 'error');
            }else{
                Message({ message: res.msg, type: 'error', duration: 5 * 1000 });
                return Promise.reject(res.msg || 'error');
            }
        }
    },
    error => {
        console.log('error:', error); // for debug
        Message({
            message: "操作失败",
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js